import React, { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { FlexContainer, PureSpinner, b64ToBlob } from 'heliocor-ui'

import {
    REQUEST_SEND_DOC_TO_SERVICE,
    SET_CURRENT_OWNER_DOC,
    DELETE_CURRENT_OWNER_DOC,
    DELETE_FILES_FROM_CURRENT_OWNER_DOC,
    REQUEST_SEND_DOC_FOR_MANUAL_VALIDATION,
    SET_CAFE_STATUS
} from '../../store/cafe/actionTypes'

import { DocumentsSection } from '../documents/DocumentsSection'
import { CommonTitle } from '../../common'
import { SendDocumentRequest } from '../documents/SendDocumentRequest'

const OwnerDocuments = ({ values, errorHandler, canEdit, mergedKYCDocs }) => {

    const { t } = useTranslation()

    const isRequest = useSelector(store => store.config.isRequest)
    const cafeStatus = useSelector(state => state.general.cafeStatus)

    const documentsUploaded = values.documents || []

    const dispatch = useDispatch()

    const uploadOwnerDoc = useCallback(
        (category, docType, url) => dispatch({ type: SET_CURRENT_OWNER_DOC, category, docType, url }),
        [dispatch]
    )

    const onUploadEnd = useCallback(
        () => dispatch({ type: SET_CAFE_STATUS, cafeStatus: 'READY' }),
        [dispatch]
    )

    const deleteDocument = useCallback(
        (docType) => dispatch({ type: DELETE_CURRENT_OWNER_DOC, docType }),
        [dispatch]
    )

    const deleteFileFromDoc = useCallback(
        ({ docType, index }) => dispatch({ type: DELETE_FILES_FROM_CURRENT_OWNER_DOC, docType, index }),
        [dispatch]
    )

    const sendForManualValidation = useCallback(
        (docType) => dispatch({ type: REQUEST_SEND_DOC_FOR_MANUAL_VALIDATION, docType, owner: values }),
        [dispatch, values]
    )



    const sendOwnerDocToService = useCallback((image, document, kind, owner, extraImage) => {
        dispatch({
            type: REQUEST_SEND_DOC_TO_SERVICE,
            image,
            extraImage,
            document,
            kind,
            owner
        })
    }, [dispatch, values.type])

    const handleDeleteDoc = (docType) => {
        deleteDocument(docType)
    }

    const handleUploadOwnerDoc = (category) => ({image, extraImage, isCore, selected}) => {
        if (isCore && ['PROOF_IDENTITY', 'PROOF_ADDRESS', 'PHOTO'].includes(category.code)) {
            sendOwnerDocToService(image, selected, category.code, values, extraImage)
        } else {
            const blob = b64ToBlob(image)
            const url = window.URL.createObjectURL(blob)
            uploadOwnerDoc(category?.code || category?.name, selected.name, url)
            onUploadEnd()
        }
    }
    
    return (
        cafeStatus === "LOADING_OWNER_DOCS"
            ? <PureSpinner margin="1rem auto" />
            : <FlexContainer column>
                {mergedKYCDocs.map((cat, index) => {
                    const {documents, localeKey, name, numberOfDocsToUpload } = cat || {}

                    return <React.Fragment key={index}>
                        <CommonTitle
                            margin="1rem 0 0 0"
                            translate={name}
                            description={numberOfDocsToUpload > 0 && t(localeKey, { min: numberOfDocsToUpload })}
                            descriptionExtras={!isRequest && (
                                <SendDocumentRequest
                                    documentCategory={cat}
                                    documents={documents}
                                    requestEmail={values?.email || values?.contactEmail}
                                />
                            )}
                        />
                        <DocumentsSection
                            contextDisabled={true}
                            documents={documents}
                            handleUpload={handleUploadOwnerDoc(cat)}
                            deleteDocument={handleDeleteDoc}
                            deleteIndividualDocument={deleteFileFromDoc}
                            documentsUploaded={documentsUploaded}
                            sendForManualValidation={sendForManualValidation}
                            canDelete={canEdit}
                            owner
                        />
                    </React.Fragment>
                })}
            </FlexContainer>
    )
}

export { OwnerDocuments }